import axios from 'axios'
import Future from 'fluture'
import {assoc, prop} from 'ramda'
import {fetchUrlBasedOnEnv, fetchLogsBasedOnEnv, getTranslationsDataUrl} from './util/helpers'
import {getSessionKey, TOKEN_KEY, USER, PASS, TOKEN} from './util/storage'

/*
 Added CORS proxy for fetching company report of a non home country
 */
export default () => {
  // const homeCountries = ['BE', 'DE', 'DK', 'NL', 'FR', 'IE', 'GB', 'US', 'NO', 'SE', 'JP']
  // added the proxy url for bypassing CORS issue
  // const proxyUrl = 'https://cors-anywhere.herokuapp.com/'

  const getBaseUrl = (env) => `${fetchUrlBasedOnEnv(env)}`
  // get User Logs url
  const getBaseLogsUrl = (env) => `${fetchLogsBasedOnEnv(env)}`
  const getTranslationsBaseUrl = (env) => `${getTranslationsDataUrl(env)}`

  const getCompleteUrl = (urlPath, env) => `${getBaseUrl(env)}/${urlPath}`

  const getCompleteLogsUrl = (urlPath, env) => `${getBaseLogsUrl(env)}/${urlPath}`
  const getTranslationsUrl = (urlPath, env) => `${getTranslationsBaseUrl(env)}${urlPath}`

  // added for DE company reports
  const customDataParamForDE = 'customData=de_reason_code::1'
  const getF = Future.encaseP2(axios.get)
  const postF = Future.encaseP3(axios.post)
  const deleteF = Future.encaseP2(axios.delete)

  // const isCORSProxyNeeded = (ggsId = '') => {
  //   let countryCode = ggsId.substring(0, 2)
  //   return homeCountries.indexOf(countryCode) === -1
  // }

  const getHeaderConfig = () => {
    return {
      'headers': {
        'Authorization': getSessionKey(TOKEN_KEY),
      },
    }
  }

  const getHeaderConfigReport = () => {
    return {
      'headers': {
        'Authorization': getSessionKey(TOKEN_KEY),
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    }
  }

  const getTranslationsHeaderConfig = () => {
    return {
      'headers': {
        'Authorization': `Basic ${TOKEN}`,
      },
    }
  }

  const getBasicAuthHeaderConfig = () => {
    var credentials = btoa(USER + ':' + PASS)
    var basicAuth = 'Basic ' + credentials
    return {
      headers: {
        'Authorization': basicAuth,
      },
    }
  }

  const addRequestUrlToResponse = (reqUrl, reqTime, type) => (data) =>
    reqTime ? assoc('responseTime', (((new Date()).getTime() - reqTime) / 1000), assoc('requestType', type, assoc('requestUrl', reqUrl, data)))
      : assoc('requestType', type, assoc('requestUrl', reqUrl, data))

  const get = (url, ggsId) => {
    let completeUrl = getCompleteUrl(url)
    // add CORS proxy only if the country is not a home country
    if (ggsId) {
      // add customData param for DE company report endpoint
      if (ggsId.substring(0, 2) === 'DE') {
        completeUrl = `${completeUrl}&${customDataParamForDE}`
      }
      // if (isCORSProxyNeeded(ggsId)) {
      //   completeUrl = `${proxyUrl}${completeUrl}`
      // }
    }
    let reqTime = (new Date()).getTime()
    return getF(completeUrl, getHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'GET'), addRequestUrlToResponse(completeUrl, reqTime, 'GET'))
  }
  const getCompanyReport = (url, ggsId) => {
    let completeUrl = getCompleteUrl(url)
    // add CORS proxy only if the country is not a home country
    if (ggsId) {
      // add customData param for DE company report endpoint
      if (ggsId.substring(0, 2) === 'DE') {
        completeUrl = `${completeUrl}&${customDataParamForDE}`
      }
      // if (isCORSProxyNeeded(ggsId)) {
      //   completeUrl = `${proxyUrl}${completeUrl}`
      // }
    }
    let reqTime = (new Date()).getTime()
    return getF(completeUrl, getHeaderConfigReport())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'GET'), addRequestUrlToResponse(completeUrl, reqTime, 'GET'))
  }
  const postAuth = (url) => (data, config, env) => {
    let completeUrl = getCompleteUrl(url, env)
    return postF(completeUrl, data, config)
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, null, 'POST'), addRequestUrlToResponse(completeUrl, null, 'POST'))
  }

  const post = (url) => (data) => {
    let completeUrl = getCompleteUrl(url)
    let reqTime = (new Date()).getTime()
    return postF(completeUrl, data, getHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'POST'), addRequestUrlToResponse(completeUrl, reqTime, 'POST'))
  }

  const del = (url, id) => {
    let completeUrl = getCompleteUrl(url)
    let reqTime = (new Date()).getTime()
    return deleteF(completeUrl, getHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'DELETE'), addRequestUrlToResponse(completeUrl, reqTime, 'DELETE'))
  }

  const getL = (url) => {
    let completeUrl = getCompleteLogsUrl(url)
    let reqTime = (new Date()).getTime()
    return getF(completeUrl, getBasicAuthHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'GET'), addRequestUrlToResponse(completeUrl, reqTime, 'GET'))
  }
  const getT = (url) => {
    let completeUrl = getTranslationsUrl(url)
    let reqTime = (new Date()).getTime()
    return getF(completeUrl, getTranslationsHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'GET'), addRequestUrlToResponse(completeUrl, reqTime, 'GET'))
  }
  const postT = (url) => (data) => {
    let completeUrl = getTranslationsUrl(url)
    let reqTime = (new Date()).getTime()
    return postF(completeUrl, data, getTranslationsHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime, 'POST'), addRequestUrlToResponse(completeUrl, reqTime, 'POST'))
  }
  return {
    authenticateUser: postAuth('authenticate'),
    searchCompanies: (params) => get(`companies?${params}`),
    getCompanyReport: (ggsId, lang) => getCompanyReport(`companies/${ggsId}?language=${lang}`, ggsId),
    getSearchCriteria: (countryList) => get(`companies/searchcriteria?countries=${countryList}`),
    getAccessCountries: () => get('access/countries'),
    getDecisionTreeList: () => get(`decisionEngine/GUID`),
    getDecisionTreeData: (provinerId, companyId) => post(`decisionEngine/${provinerId}?companyId=${companyId}`),
    getDecisionTreeDataFields: (provinerId) => get(`decisionEngine/${provinerId}/userDataFields`),
    getUserPortfolios: (page, size) => get(`monitoring/portfolios?page=${page}&pageSize=${size}`),
    searchCompaniesByPortfolio: (portfolioId, params) => get(`monitoring/portfolios/${portfolioId}/companies?${params}`),
    savePortfolio: post('monitoring/portfolios'),
    deletePortfolio: (portfolioId) => del(`monitoring/portfolios/${portfolioId}`),
    getCompanyEvents: (companyId) => get(`monitoring/companies/${companyId}/events`),
    addCompanyToPortfolio: (portfolioId) => post(`/monitoring/portfolios/${portfolioId}/companies`),
    deleteCompanyFromPorfolio: (portfolioId, companyId) => del(`/monitoring/portfolios/${portfolioId}/companies/${companyId}`),
    eventLogs: (params) => getL(`eventLogs?${params}`),
    getTranslations: ({locale, resourceSet, searchText}) => searchText ? getT(`translations?locale=${locale}&resourceSet=${resourceSet}&text=${searchText}`)
      : getT(`translations?locale=${locale}&resourceSet=${resourceSet}`),
    saveTranslations: (locale, csUserId) => postT(`translations?locale=${locale}&csUserId=${csUserId}`),
    getUserAccess: (params) => getT(`translations/access?userId=${params}`),
    getGlobalHeaderConfig: () => getHeaderConfig(),
  }
}



// WEBPACK FOOTER //
// ./src/api.js